import React from "react";
import { Link } from "react-router-dom";
import { Anchor, Box, Group } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import styles from "./PageHeaderBar.module.css";

type PageHeaderBarProps =
  | {
      label: string;
      to: string;
      onBack?: never;
      className?: string;
    }
  | {
      label: string;
      onBack: () => void;
      to?: never;
      className?: string;
    };

/**
 * Standard detail-page header bar. Renders a "← {label}" back link aligned
 * with the parent list (Reports, Clients, Products, …). Pass `to` for
 * router navigation or `onBack` for modal-style detail pages — exactly
 * one is required (enforced at compile time).
 */
export default function PageHeaderBar(props: PageHeaderBarProps) {
  const { label, className } = props;
  const inner = (
    <Group gap={6} align="center" wrap="nowrap">
      <IconArrowLeft size={18} stroke={2} />
      <Box component="span">{label}</Box>
    </Group>
  );

  return (
    <Box className={`${styles.bar} ${className || ""}`.trim()}>
      {props.to !== undefined ? (
        <Anchor
          component={Link}
          to={props.to}
          c="teal"
          fw={500}
          size="md"
          underline="hover"
        >
          {inner}
        </Anchor>
      ) : (
        <Anchor
          component="button"
          type="button"
          onClick={props.onBack}
          c="teal"
          fw={500}
          size="md"
          underline="hover"
        >
          {inner}
        </Anchor>
      )}
    </Box>
  );
}
